import { ArdoqId } from '@ardoq/api-types';
import { PerspectivesGroupsWorkspace } from '../types';
import { toWorkspaceOption } from './toOptionsMapper';
import {
  DisabledOptionProps,
  EntitiesWithPossibleDisabledOptionsName,
} from '../../types';
import { SelectOption } from '@ardoq/select';

type getWorkspaceOptionsArgs = {
  entitiesName: EntitiesWithPossibleDisabledOptionsName;
  workspaces: PerspectivesGroupsWorkspace[];
  disabledOptionProps?: DisabledOptionProps;
  firstSelectOption?: SelectOption<string>;
  entitiesPerWorkspace: Record<
    ArdoqId,
    { name: string; id: string | number }[]
  >;
};

export const getWorkspaceOptions = ({
  entitiesName,
  workspaces,
  entitiesPerWorkspace,
  disabledOptionProps,
  firstSelectOption,
}: getWorkspaceOptionsArgs) => [
  ...(firstSelectOption ? [firstSelectOption] : []),
  ...workspaces.map(workspace => {
    const hasOptions = entitiesPerWorkspace[workspace.id]?.length;
    const getPopoverContent =
      disabledOptionProps?.getDisabledWorkspacePopoverContent;

    const disabledOptionProperties =
      getPopoverContent && !hasOptions
        ? {
            isDisabled: true,
            popoverContent: getPopoverContent(entitiesName),
          }
        : undefined;

    return toWorkspaceOption(workspace, disabledOptionProperties);
  }),
];
